import React, { useEffect, useState } from "react";
import useIsTouchDevice from "../../../../../../../../../hooks/useIsTouchDevice";

export default function SubFilterCustom({
  vCategoriaProp = {},
  vIsSelected = false,
  isScrolling = false,
  setVCategoriesSelected = () => {},
}) {
  const { isTouch: isTouchDevice, isLoading } = useIsTouchDevice();

  const [vIsHover, setvIsHover] = useState(false);
  const [vStyle, setVStyle] = useState({
    backgroundColor: "green",
    color: "white",
  });

  useEffect(() => {
    console.log("Categoria Seleccionada = " + vCategoriaProp + "  Seleccionado? = " + vIsSelected)
    if (vIsHover || vIsSelected) {
      if (vCategoriaProp?.color) {
        try {
          const colorObj = JSON.parse(vCategoriaProp?.color);
          setVStyle({
            backgroundColor: colorObj.background_color.replace("0.2", "1"),
            color: "#0F172A",
          });
        } catch (error) {
          console.error("Error al parsear el color:", error);
        }
      } 
    } else {
      if (vCategoriaProp?.color) {
        try {
          const colorObj = JSON.parse(vCategoriaProp?.color);
          setVStyle({
            backgroundColor: colorObj.background_color,
            color: colorObj.text_color,
          });
        } catch (error) {
          console.error("Error al parsear el color:", error);
        }
      }
    }
  }, [vIsHover, vIsSelected]);

  if (isLoading) return null;

  return (
    <div
      className="filtros-3"
      style={vStyle}
      onMouseEnter={() => !isTouchDevice && setvIsHover(true)}
      onMouseLeave={() => setvIsHover(false)}
      onClick={(e) => {
        if (!isScrolling) {
          setVCategoriesSelected((vPrev) => {
            const idActual = Number(vCategoriaProp.id);
            const idExists = vPrev.includes(idActual);
            return idExists
              ? vPrev.filter((id) => id !== idActual)
              : [...vPrev, idActual];
          });
        }
      }}
      
    >
      <p className="filtro-area-data-texto">{vCategoriaProp.nombre}</p>
    </div>
  );
}
